export { default } from './SWProductStrip';
